import { Trans } from '@lingui/react';
import { Alert } from '@startuptools/ui/Alert';
import { Button } from '@startuptools/ui/Button';
import { Card } from '@startuptools/ui/Card';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { useAdminCompanySuspenseQuery } from './admin-company.graphql';
import { useNavigate } from '../components/Navigate';
import { useParams } from 'react-router-dom';

export const AccessAdminCompany = () => {
  const { companyId } = useParams();
  const { changeCompany } = useNavigate();

  const { data } = useAdminCompanySuspenseQuery({ variables: { id: companyId! } });
  return (
    <Stack padding={2} justifyContent="center" alignItems="center">
      <Card sx={{ maxWidth: 400 }}>
        <Stack alignItems="center" gap={2}>
          <Typography level="h3">
            <Trans id="Admin" />
          </Typography>
          <Alert>You are about to access {data.adminCompany.name} using admin mode.</Alert>
          <Button
            color="primary"
            onClick={async () => {
              const id = data.adminCompany.id;
              const userId = data.adminCompany.companyUsers[0]?.user?.id;
              if (!id || !userId) {
                throw new Error('no company user found');
              }
              await fetch(`/next-api/imitate-user?userId=${userId}`, {
                credentials: 'same-origin',
              });
              void changeCompany(id);
            }}
          >
            <Trans id="Continue" />
          </Button>
        </Stack>
      </Card>
    </Stack>
  );
};
